const routes = [
  {
    path: '/apis/providers',
    name: 'apis-providers-list',
    component: () => import(/* webpackChunkName: "page/apis/providers/list" */'@/views/pages/apis/providers/List'),
    meta: {
      permissions: 'api_providers_read'
    }
  },
  {
    path: '/apis/providers/new',
    name: 'apis-providers-new',
    component: () => import(/* webpackChunkName: "page/apis/providers/new" */'@/views/pages/apis/providers/New'),
    meta: {
      permissions: 'api_providers_write'
    }
  },
  {
    path: '/apis/providers/:id',
    name: 'apis-providers-single',
    component: () => import(/* webpackChunkName: "page/apis/providers/single" */'@/views/pages/apis/providers/Single'),
    meta: {
      permissions: 'api_providers_read'
    }
  },
  {
    path: '/apis/providers/:id/edit',
    name: 'apis-providers-edit',
    component: () => import(/* webpackChunkName: "page/apis/providers/edit" */'@/views/pages/apis/providers/Edit'),
    meta: {
      permissions: 'api_providers_write'
    }
  }
]

export default routes
